import { CSSProperties, FC } from "react"
import Typography, { EnhancedParagraphProps } from "../typography/Typography"

const { Paragraph } = Typography
type Props = {
  text: Maybe<string>
  rows?: number
  maxWidth?: number
  style?: CSSProperties
  // Set false when the caller already wraps the text in its own Tooltip, or both show at once.
  tooltip?: boolean
  // Legacy prop still passed by callers; truncation is driven by `rows`. Kept out of restProps so it doesn't reach the DOM.
  ellipsisLength?: number
}
const EllipsisText: FC<Props & Partial<EnhancedParagraphProps>> = ({
  style,
  text,
  rows = 3,
  maxWidth,
  tooltip = true,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ellipsisLength,
  ...restProps
}) => {
  return (
    <Paragraph
      {...restProps}
      font={"regular"}
      style={{ marginBottom: 0, maxWidth: maxWidth ?? 200, minWidth: 0, ...style }}
      ellipsis={{
        rows,
        suffix: "",
        tooltip: tooltip ? text : undefined,
      }}
    >
      {text}
    </Paragraph>
  )
}

export default EllipsisText
